import { render, staticRenderFns } from "./FirmwareVersionTable.vue?vue&type=template&id=7648eb7b"
import script from "./FirmwareVersionTable.vue?vue&type=script&lang=js"
export * from "./FirmwareVersionTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports